import { HiInformationCircle } from 'react-icons/hi';
import cn from 'classnames';

import { Checkbox, Radio } from 'modules/common';

export const dispatchType = () => ({
  default: {
    background: 'bg-primitive-white',
    border: 'border border-default',
  },
  secondary: {
    background: 'bg-brand-secondary-base',
    text: 'text-primitive-white',
    border: 'border border-brand-secondary-base',
  },
});

export const dispatchLeadingType = ({
  selectionProps,
  iconProps,
  type,
} = {}) => {
  const dispatchIconType = {
    default: (
      <HiInformationCircle
        {...iconProps}
        className={cn('h-[18px] w-[18px]', iconProps?.className)}
      />
    ),
    secondary: (
      <HiInformationCircle
        {...iconProps}
        className={cn(
          'h-[18px] w-[18px] text-primitive-white',
          iconProps?.className
        )}
      />
    ),
  };

  return {
    checkbox: <Checkbox {...selectionProps} />,
    radio: <Radio {...selectionProps} />,
    info: dispatchIconType?.[type],
  };
};
